module.exports = __webpack_public_path__ + "img/ico-help.fcab47c0.svg";